import { render, staticRenderFns } from "./PagesVideoWidget.vue?vue&type=template&id=66e6e340&scoped=true&"
import script from "./PagesVideoWidget.vue?vue&type=script&lang=js&"
export * from "./PagesVideoWidget.vue?vue&type=script&lang=js&"
import style0 from "./PagesVideoWidget.vue?vue&type=style&index=0&id=66e6e340&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e6e340",
  null
  
)

export default component.exports